import { Message } from "element-ui/lib/element-ui.common";
export default {
  install(Vue, options) {
    var fromDisable = true; //表单可提交状态
    // 1. 添加全局方法或属性
    /*Vue.myGlobalMethod = function() {
			// 逻辑...
			alert(1);
		}
		// 2. 添加全局资源
		Vue.directive('my-directive', {
			bind(el, binding, vnode, oldVnode) {
				// 逻辑...
			}
		})
		// 3. 注入组件
		Vue.mixin({
			created: function() {
				// 逻辑...
			}
		})*/
    /**
     * @author：ww
     * @function: 对象深度拷贝
     * @pramas: obj 需要拷贝的对象 必填
     * 			obj2 拷贝生成的对象(默认返回对象，如果是数组需要传,eg:function(obj,[])) 非必填
     */
    (Vue.prototype.$extendDeepCopy = function(obj, obj2) {
      var newobj = obj2 || {};
      for (var i in obj) {
        if (typeof obj[i] === "object" && obj[i] !== null) {
          newobj[i] = obj[i].constructor === Array ? [] : {};
          this.$extendDeepCopy(obj[i], newobj[i]);
        } else {
          newobj[i] = obj[i];
        }
      }
      return newobj;
    }),
      /**
		 * @author：ww
		 * @function: 时间格式化
		 * @pramas: 1."times": 可以为秒或者毫秒，必填
		 		    2."formatStr": 返回时间格式 非必填
		 */
      (Vue.prototype.$format = function(times, formatStr) {
        if (/^\d{12,14}$/.test(times)) {
          var timestamp = times;
        } else if (/^\d{9,11}$/.test(times)) {
          var timestamp = times * 1000;
        } else {
          return times;
        }
        var format = formatStr || "yyyy/MM/dd";
        var currentDate = new Date(parseInt(timestamp));
        var date = {
          "M+": currentDate.getMonth() + 1,
          "d+": currentDate.getDate(),
          "h+": currentDate.getHours(),
          "m+": currentDate.getMinutes(),
          "s+": currentDate.getSeconds()
        };
        if (/(y+)/i.test(format)) {
          format = format.replace(
            RegExp.$1,
            (currentDate.getFullYear() + "").substr(4 - RegExp.$1.length)
          );
        }
        for (var k in date) {
          if (new RegExp("(" + k + ")").test(format)) {
            format = format.replace(
              RegExp.$1,
              RegExp.$1.length == 1
                ? date[k]
                : ("00" + date[k]).substr(("" + date[k]).length)
            );
          }
        }
        return format;
      }),
      /**
       * @author：ww
       * @function: 人员单选选择框
       * @pramas: el-autocomplete 必须基于这个控件使用
       */
      (Vue.prototype.$singlePersonSelect = function(queryString, cb) {
        var that = this;
        if (
          /^[\u4e00-\u9fa5]/g.test(queryString) ||
          /^\d{3,}$/.test(queryString)
        ) {
          this.timeOut && clearTimeout(this.timeOut);
          this.timeOut = setTimeout(function() {
            that
              .$httpExt()
              .post("common/queryEmp", {
                pageNum: 1,
                pageSize: 10,
                likeStr: queryString
              })
              .then(
                function(response) {
                  let results = response.result.list;
                  for (let [index, item] of results.entries()) {
                    item.value = item.lastName + "(" + item.empNum + ")";
                  }
                  cb(results);
                },
                function(response) {
                  Message({
                    message: response.msg,
                    type: "warning"
                  });
                }
              );
          }, 500);
        } else {
          cb([]);
        }
      }),
      /**
       * @author：ww
       * @function: 组织单选选择框
       * @pramas: el-autocomplete 必须基于这个控件使用
       */
      (Vue.prototype.$singleOrgSelect = function(queryString, cb) {
        var that = this;
        if (
          /^[\u4e00-\u9fa5]/g.test(queryString) ||
          /^[A-Za-z0-9]{2,}$/.test(queryString)
        ) {
          this.timeOut && clearTimeout(this.timeOut);
          this.timeOut = setTimeout(function() {
            that
              .$httpExt()
              .post("common/queryOrg", {
                paging: 1,
                pageNum: 1,
                pageSize: 10,
                likeStr: queryString,
                region: "all"
              })
              .then(
                function(response) {
                  let results = response.result.list;
                  for (let [index, item] of results.entries()) {
                    item.value = item.orgName;
                  }
                  cb(results);
                },
                function(response) {
                  Message({
                    message: response.msg,
                    type: "warning"
                  });
                }
              );
          }, 500);
        } else {
          cb([]);
        }
      }),
      /**
       * @author：xmj
       * @function: 防重
       * @pramas: btn  可传可不传 传了btn置灰
       */
      (Vue.prototype.$checkPrevent = function(btn) {
        if (fromDisable) {
          // 验证表单状态是否为可以提交状态
          fromDisable = false; // 点击后 把状态改为 不可提交
          setTimeout(function() {
            fromDisable = true;
          }, 3000); // 三秒之后把表单状态重新设置为可提交
          if (typeof btn != "undefined") {
            // 验证是否传入值
            btn.style.background = "#ddd"; // 把按钮颜色置灰
            btn.style.color = "#fff"; // 把按钮颜色置灰
            btn.style.border = 0; // 把按钮颜色置灰
            setTimeout(function() {
              btn.style.background = "";
              btn.style.color = "";
              btn.style.border = "";
            }, 3000); // 三秒后重新改为启用
          }
          return true; // 如果状态为可提交 返回true
        } else {
          return false;
        }
      }),
      (Vue.prototype.$getCookie = function(name) {
        var data = document.cookie;
        var dataArray = data.split("; ");
        for (var i = 0; i < dataArray.length; i++) {
          var varName = dataArray[i].split("=");
          if (varName[0] === name) {
            return decodeURI(varName[1]);
          }
        }
      }),
      (Vue.prototype.$delAllCookie = function() {
        var myDate = new Date();
        myDate.setTime(-1000); //设置时间
        var data = document.cookie;
        var dataArray = data.split("; ");
        for (var i = 0; i < dataArray.length; i++) {
          var varName = dataArray[i].split("=");
          document.cookie = varName[0] + "=''; expires=" + myDate.toGMTString();
        }
      });
  }
};



// WEBPACK FOOTER //
// ./src/common/js/method.js